import { Link } from '@tanstack/react-router';
import { useCrumbs } from '../layout/crumbs';
import { Page } from '../ui/layout';

export function NotFoundPage() {
  useCrumbs([{ label: 'Страница не найдена' }]);
  return (
    <Page>
      <div className="max-w-xl py-16">
        <h1 className="text-[24px] leading-8 font-semibold text-ink">Такой страницы нет</h1>
        <p className="mt-2 text-[14px] text-ink-2">
          Ссылка устарела или в ней опечатка. Откройте нужный раздел из меню или перейдите на главную.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-[14px] font-medium text-accent-text underline underline-offset-4"
        >
          На главную
        </Link>
      </div>
    </Page>
  );
}
